import { ScrollArea, Table } from '@mantine/core';
import { memo } from 'react';
import type { RowError } from './ErrorsTable.types';

interface Props {
	errors: RowError[];
	maxHeight?: number;
}

const ErrorsTable = ({ errors, maxHeight }: Props) => {
	if (errors.length === 0) {
		return null;
	}

	return (
		<ScrollArea h={maxHeight} mt={8}>
			<Table
				fz="xs"
				verticalSpacing={4}
				styles={(theme) => ({
					thead: {
						tr: {
							th: {
								backgroundColor: theme.colors.gray[0],
								borderBottom: `1px solid ${theme.colors.gray[2]}`,
								fontWeight: 600,
								padding: '8px 12px',
							},
						},
					},
					tbody: {
						tr: {
							td: {
								borderBottom: `1px solid ${theme.colors.gray[2]}`,
								padding: '8px 12px',
							},
							'&:last-of-type td': {
								borderBottom: 'none',
							},
						},
					},
				})}
			>
				<thead>
					<tr>
						<th>Row</th>
						<th>Error</th>
						<th>Source</th>
						<th>Destination</th>
						<th>Security</th>
					</tr>
				</thead>
				<tbody>
					{errors.map((err) => (
						<tr key={err.rowIndex}>
							<td>{err.rowIndex}</td>
							<td>{err.error}</td>
							<td>{err.transaction.source}</td>
							<td>{err.transaction.destination}</td>
							<td>{err.transaction.securityName}</td>
						</tr>
					))}
				</tbody>
			</Table>
		</ScrollArea>
	);
};
const _ErrorsTableExport = memo(ErrorsTable);

export { _ErrorsTableExport as ErrorsTable };
